import { getApp, getApps, initializeApp } from 'firebase/app';
import { firebaseConfig } from 'assets/data/config';

export default defineNuxtPlugin({
  name: 'firebase',
  parallel: true,
  setup() {
    const firebaseApp = getApps().length
      ? getApp()
      : initializeApp(firebaseConfig);

    window.firebaseConfig = firebaseConfig;

    return {
      provide: {
        firebaseApp,
      },
    };
  },
});
